import {get, listAll, post, postFormData} from './utils';

const dao = {
  listAllCategory: params => listAll(dao.listCategory, params),
  listCategory: async params =>
    get('/smb-backend/product/list-products.action', params),
  createCategory: params =>
    post('/smb-backend/product/create-product.action', params),
  updateCategory: params =>
    post('/smb-backend/product/update-product.action', params),
  deleteCategory: params =>
    post('/smb-backend/product/delete-product.action', params),
  orderCategory: params =>
    post('/smb-backend/product/update-product-order.action', params),
  listAllLens: params => listAll(dao.listLens, params),
  listLens: params => post('/smb-backend/lens/list-lenses.action', params),
  createLens: params => post('/smb-backend/lens/create-lens.action', params),
  updateLens: params => post('/smb-backend/lens/update-lens.action', params),
  deleteLens: params => post('/smb-backend/lens/delete-lens.action', params),
  orderLens: params =>
    post('/smb-backend/lens/update-lens-order.action', params),
  existLensId: params => get('/smb-backend/lens/exist-lens-no.action', params),
  createProduct: params =>
    post('/smb-backend/product/create-product.action', params),
  updateProduct: params =>
    post('/smb-backend/product/update-product.action', params),
  queryProduct: productId =>
    post('/smb-backend/product/query-product.action', {productId}),
  listAllProduct: params => listAll(dao.listProduct, params),
  listProduct: params =>
    get('/smb-backend/product/list-products.action', params),
  createSku: params => post('/smb-backend/sku/create-sku.action', params),
  updateSku: params => post('/smb-backend/sku/update-sku.action', params),
  querySku: skuId => get('/smb-backend/sku/query-sku.action', {skuId}),
  queryProductBySku: skuId =>
    get('/smb-backend/product/query-product-by-sku.action', {skuId}),
  listCompleteSku: params => get('/smb-backend/sku/list-skus.action', params),
  listAllSku: params => listAll(dao.listSku, params),
  listSku: params =>
    get('/smb-backend/sku/list-skus-by-sku-type.action', params),
  listAllSkuByType: params => listAll(dao.listSkuByType, params),
  listSkuByType: params =>
    get('/smb-backend/sku/list-skus-by-sku-type.action', params),
  listSkusWithConsoleId: () =>
    get('/smb-backend/sku/list-skus-with-console-id.action'),
  copySku: skuId => get('/smb-backend/sku/copy-sku.action', {skuId}),
  enableSku: skuId => get('/smb-backend/sku/enable-sku.action', {skuId}),
  disableSku: skuId => get('/smb-backend/sku/disable-sku.action', {skuId}),
  countEnabled: () => get('/smb-backend/sku/count-enabled.action'),
  countCreated: () => get('/smb-backend/sku/count-created.action'),
  deleteProduct: productId =>
    get('/smb-backend/product/delete-product.action', {productId}),
  deleteSku: skuId => get('/smb-backend/sku/delete-sku.action', {skuId}),
  updateProductOrder: params =>
    post('/smb-backend/product/update-product-order.action', params),
  updateSkuOrder: params =>
    post('/smb-backend/sku/update-sku-order.action', params),
  updateProductSkus: params =>
    post('/smb-backend/product/update-product-skus.action', params),
  enableProduct: productId =>
    get('/smb-backend/product/enable-product.action', {productId}),
  disableProduct: productId =>
    get('/smb-backend/product/disable-product.action', {productId}),
  removeImageBackground: file =>
    postFormData('/smb-backend/yce/remove-image-background.action', file),
  createProductByLibrary: params =>
    post('/smb-backend/product/create-product-by-pf-library.action', params),
  queryLibraryByproductId: productId =>
    post('/smb-backend/product/query-pf-library-product.action', productId),
  listLibraryBrands: () =>
    get('/smb-backend/product/list-pf-library-brands.action'),
  listLibraryProducts: params =>
    get('/smb-backend/product/list-pf-library-products.action', params),
  uploadFileV2: formData => postFormData(`/api/v2/files`, formData),
  autoProcess: params => post('/api/v2/skus/eyewear-2d-auto-process', params),
  queryAutoProcessStatus: params =>
    get('/api/v2/skus/eyewear-2d-auto-process-status', params),
};

export default dao;
